// extracted by mini-css-extract-plugin
module.exports = {"dni_file_representative":"legal-styles_dni_file_representative__3O8jQ"};